module.exports = __webpack_public_path__ + "img/williams.cd3839d7.webp";